<template>
    <b-col cols="12" class="mt-3 dd">
        <label class="mb-3"><strong>{{ $translate('roles') }}<span class="red">*</span></strong></label>
        <b-form-select class="form-control" required v-custom-validation="$selectRequired()" v-model="selectedRole"
            :options="allRoles" name="radios-stacked" text-field="name" value-field="id" :stacked="stacked">
            <template #first>
                <b-form-select-option :value="null">{{ $translate('select_role') }}</b-form-select-option>
            </template>
        </b-form-select>
    </b-col>
</template>
<script>
export default {
    data() {
        return {
            selectedRole: null,
        }
    },
    props: ['allRoles', 'value', 'stacked', 'labelCols', 'labelClass'],
    watch: {
        selectedRole: function (id) {
            const item = this.allRoles.find(x => x.id == id) || {}
            console.log('item', item)
            this.$emit('input', [item.name])
        },
        value: function (value) {
            this.processValue(value)
        },
    },

    mounted() {
        this.processValue(this.value)
    },
    methods: {
        processValue(value) {
            console.log('value', value)
            const role_name = value ? value[0] : null
            const selectedRole = this.allRoles.find(x => x.name == role_name)
            this.selectedRole = selectedRole ? selectedRole.id : null
            console.log(' this.selectedRole', this.selectedRole)
        },
    },
}
</script>
